import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HttpCacheInterceptorModule, useHttpCacheLocalStorage } from '@ngneat/cashew';
import { EdAssistUIFooterModule } from '@edassist-ui/footer';
import { EdAssistUIGlobalAlertsModule } from '@edassist-ui/global-alerts';
import { EdAssistUISessionTimeoutModalModule } from '@edassist-ui/session-timeout';
import { AppConfigService, AppTitleService, WINDOW_PROVIDERS } from '@edassist/common';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
	ApiEndpointInterceptor,
	ErrorInterceptor,
	HttpCredentialsInterceptor,
	HttpHeadersInterceptor,
	QueueRequestInterceptor
} from '@edassist/api';
import { SliderService } from '@edassist-ui/services';
import { EdAssistUINavbarTopHeaderModule } from './shared/components/tuition-navbar-top-header';
import { NotificationsModule } from '@edassist/common/components/notifications/notifications.module';
import { CookieService } from 'ngx-cookie-service';
import { GoogleTagManagerConfiguration, GoogleTagManagerModule } from 'angular-google-tag-manager';
import { NgIdleModule } from '@ng-idle/core';
import { ExternalNavigationModalModule } from '@edassist/common/components/external-navigation-modal/external-navigation-modal.module';
import { EdMarketPlaceSurveyModule } from './modules/ed-market-place-survey/ed-market-place-survey.module';

// tslint:disable-next-line
export function initializeApp(appConfigService: AppConfigService, gtmConfig: GoogleTagManagerConfiguration) {
	return async () => appConfigService.load(environment.name, gtmConfig);
}

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		AppRoutingModule,
		EdAssistUIFooterModule,
		EdAssistUIGlobalAlertsModule,
		EdAssistUINavbarTopHeaderModule,
		EdAssistUISessionTimeoutModalModule,
		ExternalNavigationModalModule,
		EdMarketPlaceSurveyModule,
		BrowserAnimationsModule,
		NgIdleModule.forRoot(),
		HttpClientModule,
		HttpCacheInterceptorModule.forRoot({ ttl: 900000 }),
		NotificationsModule,
		GoogleTagManagerModule.forRoot()
	],
	providers: [
		AppConfigService,
		AppTitleService,
		WINDOW_PROVIDERS,
		{
			provide: APP_INITIALIZER,
			useFactory: initializeApp,
			deps: [AppConfigService, GoogleTagManagerConfiguration],
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ApiEndpointInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpCredentialsInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpHeadersInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: QueueRequestInterceptor,
			multi: true
		},
		{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
		SliderService,
		CookieService,
		useHttpCacheLocalStorage
	],
	bootstrap: [AppComponent]
})
export class AppModule {}
